export default {
  data() {
    return {
      sortByOptions: [
        {
          value: `${this.$store.state.typesense.collectionName}`,
          label: this.gettext('Relevantie'),
        },
        {
          value: `${this.$store.state.typesense.collectionName}/sort/price_eur:asc`,
          label: this.gettext('Prijs: Laag - Hoog'),
        },
        {
          value: `${this.$store.state.typesense.collectionName}/sort/price_eur:desc`,
          label: this.gettext('Prijs: Hoog - Laag'),
        },
        {
          value: `${this.$store.state.typesense.collectionName}/sort/created_unix:asc`,
          label: this.gettext('Date: Old - New'),
        },
        {
          value: `${this.$store.state.typesense.collectionName}/sort/created_unix:desc`,
          label: this.gettext('Date: New - Old'),
        },
      ],
    };
  },
};
